import {ForumContext, ForumProvider} from "../../context/forumContext";
import {useContext, useEffect} from "react";
import Body from "../common/Body";
import NodeList from "./ForumIndex/section/NodeList";
import HtmlParsedText from "../common/HtmlParsedText";
import {WidgetContext} from "../../context/widgetContext";
import ThreadList from "./ForumIndex/section/ThreadList";
import {ForumStatisticsProvider} from "../../context/forumStatisticsContext";
import {AuthContext} from "../../context/authContext";
import {boardUrl, DESCRIPTION, TITLE} from "../../config/config";
import {generateHeadTags} from "react-seo-tools";
import {Helmet} from "react-helmet";
import VideoList from "./ForumIndex/section/VideoList";

const SidebarContent = () => {
	const {
		forum_overview_members_online,
		forum_overview_new_posts,
		forum_overview_forum_statistics,
		tag_cloud,
		fetchWidgetHtml
	} = useContext(WidgetContext);

	fetchWidgetHtml('forum_overview_members_online');
	fetchWidgetHtml('forum_overview_new_posts');
	fetchWidgetHtml('forum_overview_forum_statistics');
	fetchWidgetHtml('tag_cloud');

	return (
		<>
			<div className="mb-4">
				{forum_overview_members_online && (<HtmlParsedText text={forum_overview_members_online}/>)}
			</div>

			<div className="mb-4">
				{forum_overview_new_posts && (<HtmlParsedText text={forum_overview_new_posts}/>)}
			</div>

			<div className="mb-4">
				{forum_overview_forum_statistics && (<HtmlParsedText text={forum_overview_forum_statistics}/>)}
			</div>

			<div className="mb-4">
				{tag_cloud && (<HtmlParsedText text={tag_cloud}/>)}
			</div>
		</>
	);
}

const HeroContent = () => {
	const {visitor} = useContext(AuthContext);

	return (
		<div className="px-2 pt-2 md:px-4 md:pt-4">
			<div className="block items-center text-white mb-2 lg:flex">
				<div>
					<h1 className="text-lg font-medium">
						{TITLE}
					</h1>
					<p className="hidden text-sm lg:block">
						{DESCRIPTION}
					</p>
				</div>

				<div className="inline-flex items-center gap-x-2 ml-auto">
					<a href={`${boardUrl}/index.php?whats-new/posts`} className="button"><span className="button-text">Chủ đề mới</span></a>
					<a href={`${boardUrl}/index.php?forums/-/create-thread`} className="button button--cta" rel="nofollow"><span className="button-text">Đăng bài…</span></a>
				</div>
			</div>

			<ThreadList/>

			{visitor && visitor.can_view_videos && (
				<VideoList />
			)}
		</div>
	)
}

const MainContent = () => {
	const {visitor} = useContext(AuthContext);
	const {nodeTree, nodes, fetchNodeList} = useContext(ForumContext);

	fetchNodeList();

	return (
		<div>
			<Helmet>
				{generateHeadTags({
					title: TITLE,
					description: DESCRIPTION,
					openGraph: {
						type: 'website',
						title: TITLE,
					},
				})}
			</Helmet>

			{(visitor && visitor.user_id && visitor.can_view_chat) && (
				<section className="mb-4">
					<iframe title="Chat" src={`${boardUrl}/index.php?chat/fullpage`} width="100%"
					        height="450"></iframe>
				</section>
			)}

			{(nodeTree && nodes) && (
				<section className="mb-4">
					<NodeList nodes={nodes} nodeTree={nodeTree} />
				</section>
			)}
		</div>
	);
}

const ForumIndex = () => {
	useEffect(() => {
		document.title = TITLE;
		document.querySelector('meta[name="description"]').setAttribute("content", DESCRIPTION);
	}, []);

	return <ForumProvider><ForumStatisticsProvider>
		<Body mainContent={<MainContent />}
		      heroContent={<HeroContent />}
		      sidebarContent={<SidebarContent />} />
	</ForumStatisticsProvider></ForumProvider>
}

export default ForumIndex;